/* globals Profile */
import 'lib/profile'

window['employees/appraisal/interviews#new'] =
  window['employees/appraisal/interviews#edit'] = function () {
    Profile.initCheckboxPerformance()
    Profile.closeEditablesBeforeSaveHTML()
  }
